import React from 'react';
import { Box } from '@mui/material';
import FilterChip from './FilterChip';

export const ACTIVE_STATUSES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};

const STATUS_CONFIG = {
  [ACTIVE_STATUSES.ACTIVE]: {
    label: 'Active',
    backgroundColor: '#E6F4EA',
    textColor: '#1E8E3E',
    borderColor: '#1E8E3E'
  },
  [ACTIVE_STATUSES.INACTIVE]: {
    label: 'Inactive',
    backgroundColor: '#F3F4F6',
    textColor: '#6B7280',
    borderColor: '#6B7280'
  }
};

const ActiveStatus = ({
  selectedStatuses = [],
  onStatusToggle,
  sx = {}
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', ...sx }}>
      {Object.values(ACTIVE_STATUSES).map((status) => {
        const isSelected = selectedStatuses.includes(status);
        const config = STATUS_CONFIG[status];

        return (
          <FilterChip
            key={status}
            label={config.label}
            isSelected={isSelected}
            onClick={() => onStatusToggle(status)}
            backgroundColor={config.backgroundColor}
            textColor={config.textColor}
            borderColor={config.borderColor}
            showDot={true}
          />
        );
      })}
    </Box>
  );
};

export default ActiveStatus;
